import breakpoints from 'static/script/utils/breakpoints';

/**
 * Composes a valid string representation of channels for an adsense request,
 * trimms illeagal characters and replaces space (' ') with inderscore ('_')
 * @param {string[]} channels - array of strings representing each channel
 * @returns {string}
 */
const formatChannelString = channels => {
    const formattedChannels = channels.map(channel =>
        channel
            ? channel
                  .toLowerCase()
                  .replace(/[^a-z0-9\s_]/g, '') // remove all illeagal characters
                  .replace(/\s+/g, '_') // replace space with _
            : null
    );

    return formattedChannels.join('+'); // + is the adsense channel separator
};

/**
 * Composes adsense channel from several sources
 * @param {string} pageType - e.g. browse or search
 * @param {string[]} additionalChannels
 * @returns {string}
 */
const composeAdsenseChannel = (pageType, additionalChannels = []) => {
    let channels = ['web'];

    if (breakpoints.isVisible(breakpoints.xlarge)) {
        channels.push(`${pageType}_large`);
    } else if (breakpoints.isVisible(breakpoints.large)) {
        channels.push(`${pageType}_medium`);
    } else {
        channels.push(`${pageType}_small`);
    }

    return formatChannelString([...channels, ...additionalChannels]);
};

export { composeAdsenseChannel, formatChannelString };
